import React, {ChangeEvent, useEffect, useState} from "react";
import {Form, Label} from "semantic-ui-react";
import {SurveyFormQuestionModel, SurveyFormQuestionType} from "../../model/SurveyFormModel";
import SurveyFormChoiceList from "./SurveyFormChoiceList";

interface Props {
    question: SurveyFormQuestionModel,
    onChanged?: (question: SurveyFormQuestionModel) => void;
    readOnly?: boolean;
}

const SurveyFormEditorQuestion = ({question, onChanged, readOnly}: Props) => {
    function handleChange(data: any) {
        if (onChanged) {
            Object.assign(question, data);
            onChanged(question);
        }
    }

    return (
        <Form>
            <Form.Field>
                <label>Код</label>
                <Form.Input
                    readOnly={readOnly}
                    value={question.id}
                    maxLength={20}
                    onChange={(e) => handleChange({id: e.target.value})}
                />
            </Form.Field>

            <Form.Field>
                <label>Вопрос</label>
                <Form.Input
                    placeholder='Вопрос'
                    readOnly={readOnly}
                    maxLength={300}
                    value={question.questionDisplayText}
                    onChange={(e) => handleChange({questionDisplayText: e.target.value})}
                />
            </Form.Field>
            {question.type == SurveyFormQuestionType.choice &&
                <>
                    <Form.Field>
                        <label>Варианты ответов</label>
                        <SurveyFormChoiceList choices={question.choices} readOnly={readOnly}
                                              onChanged={(value) => handleChange({choices: value})} />
                    </Form.Field>
                    <Form.Group inline>
                        <Form.Checkbox label={`Множественный выбор`}
                                       checked={question.multiselect}
                                       readOnly={readOnly}
                                       onChange={(event, data) => handleChange({multiselect: data.checked})}/>
                        <Form.Field>
                            <label>Максимальное число ответов</label>
                            <Form.Input
                                key={question.id}
                                type="number"
                                min={1}
                                max={50}
                                readOnly={readOnly}
                                value={question.multiselectMaxAnswerCount}
                                onChange={(e) => handleChange({multiselectMaxAnswerCount: e.target.value ? Math.max(1, Number(e.target.value)) : undefined})}/>

                        </Form.Field>
                    </Form.Group>
                </>}
        </Form>);
}

export default SurveyFormEditorQuestion;